import { AxiosResponse } from "axios";
import axiosInstance from "./base";
import { TtrackCondition } from "../shared/types/trackCondition.type";

export class TrackCondition {

    static geTtrackConditions(trainer?: number): Promise<AxiosResponse<Array<TtrackCondition>>> {
        return axiosInstance.get(`track_conditions?trainer=${trainer}&itemsPerPage=1000`)
    }

    static save(data: Partial<TtrackCondition>): Promise<AxiosResponse<TtrackCondition>> {
        return axiosInstance.post('track_conditions', data)
    }

    static update(data: Partial<TtrackCondition>): Promise<AxiosResponse<TtrackCondition>> {
        return axiosInstance.patch(`track_conditions/${data.id}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }

    static delete(id: number) {
        return axiosInstance.delete(`track_conditions/${id}`)

    }

}